import React from 'react';
import { useEffect, useState } from 'react';
import { postAPI } from '../../api/api';
import { REACT_APP_CANDIDATE_FRELLANCER } from '../../utils/common';
import Styles from './styles.module.scss'

interface props {
    fileName: string | null;
}

const DocumentViewer: React.FC<props> = ({
    fileName
}) => {

    const [fileUrl, setFileUrl] = useState<string>('');
    const extension: string | undefined = fileName?.split('.')[1];
  console.log(extension)

    useEffect(() => {
        if (fileName) {
            downloadSignedUrl();
        }
    }, [fileName])
    
    const downloadSignedUrl = () => {
        let value = {
            "action":"getObject",
            "filename":fileName,
            "bucketName":"ellow-prod-doc-upload",
        };
        
        postAPI(REACT_APP_CANDIDATE_FRELLANCER + '/resume-signed-url', value).then((data) => {
            setFileUrl(data.url);
        })
  }


  return (
      <div className={Styles.custom_Iframe}>
      <iframe
        src = {`https://docs.google.com/gview?url=${encodeURIComponent(fileUrl)}&embedded=true`}
        title = "Document Viewer"
        width = "600"
        height="1000"
        
      />
    </div>
  );
};

export default DocumentViewer;